import { reducePanDomain } from '../../../../core/components/interactions-state-helpers/reducers/pan-reducers.js';
import { useSynchronizedSelection } from '../../../../core/components/shared-chart-interactions/hooks/useSynchronizedSelection.js';
import { getNextPanDomain } from '../../../../core/components/zoom/utils/get-next-pan-domain.js';
import { useSetState } from '../../../hooks/store/selectors.js';
import { useChartInteractions } from '../../../hooks/useChartInteractions.js';
import { useInfiniteZoomConfig } from '../../../hooks/useInfiniteZoomConfig.js';
import { useXScales } from '../../../hooks/useXScale.js';

/**
 * Returns a callback which given a delta in pixels, will apply the pan interaction and update the state accordingly
 */
export const useApplyPanDelta = () => {
  const { onZoomChange } = useChartInteractions();
  const { currentScale: xScale, initialScale: initialXScale } = useXScales();
  const infiniteZoom = useInfiniteZoomConfig();
  const { resetSelectionState } = useSynchronizedSelection();
  const setState = useSetState();

  const initialXDomain = initialXScale.domain();

  return (delta: number) => {
    const [min, max] = getNextPanDomain(
      [+initialXDomain[0], +initialXDomain[1]],
      xScale,
      -delta,
      false,
      infiniteZoom,
    );

    resetSelectionState?.();
    onZoomChange?.(new Date(min), new Date(max), 'panning');
    setState(reducePanDomain([min, max]));
  };
};
